module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0062.jpg?v=7335366c";